import { ExamSubmissionSummaryProps } from "./ExamSubmissionSummary";

export const examSubmissionSummaryPlaceholderProps: ExamSubmissionSummaryProps = {
  totalQuestionsCount: 200,
  notAnsweredCount: 50,
  markedForReviewCount: 20,
  notVisitedCount: 80,
  // timeTakenMinutes: 40,
  answeredCount: 50,
};
